import { lazy, Suspense, ReactNode } from 'react';
import { compose } from 'recompose';

import { ErrorBoundary } from '~/components/Tools';
import { StyledAdminShellLayout, StyledBerryWidget } from './styles';
import GlobalHeaderLoader from '~/components/GlobalHeader/Admin/Loader';
import Navigation from '~/components/Navigation';
import Maintenance from '~/components/Maintenance';
import { BERRY_WIDGET_ID } from '~/config/app.constants';
import { withConditionalLayout } from '../hocs/withConditionalLayout';
import { withOtherRemotes } from '../hocs/withOtherRemotes';

const GlobalAdminHeaderLazy = lazy(() => import('~/components/GlobalHeader/Admin'));

const BaseAdminLayout = ({ children }: { children?: ReactNode }) => (
  // const offset = useHeaderOffset();
  <StyledAdminShellLayout>
    <ErrorBoundary>
      <Maintenance isAdmin />
    </ErrorBoundary>
    <ErrorBoundary>
      <Suspense fallback={<GlobalHeaderLoader />}>
        <GlobalAdminHeaderLazy />
      </Suspense>
    </ErrorBoundary>
    <div className="shell-layout-admin-content">
      <ErrorBoundary>
        <Navigation />
      </ErrorBoundary>
      <div className="shell-layout-admin-content-wrapper">
        <StyledBerryWidget id={BERRY_WIDGET_ID}></StyledBerryWidget>
        {children}
      </div>
    </div>
  </StyledAdminShellLayout>
);

const Layout = compose(withOtherRemotes, withConditionalLayout)(BaseAdminLayout);

export default Layout;
